import { AwsUi } from '../../../core/runtime/src';
import { KeyCode, addClass } from '../../../core/utils/src/dom';
import BemClassBuilder from '../../../core/utils/src/class-builders/bem';
var DROPDOWN_PADDING = 50;
function fitDropdown(dropdownNode) {
    var referenceElement = dropdownNode.previousElementSibling;
    if (referenceElement && dropdownNode) {
        var dropdownCb = new BemClassBuilder({ __componentName: 'awsui-input-dropdown' }, 'dropdown');
        var windowHeight = window.innerHeight;
        var dropdownHeight = dropdownNode.scrollHeight;
        var referenceBoundingRect = referenceElement.getBoundingClientRect();
        var availableSpaceBelow = windowHeight - referenceBoundingRect.bottom - DROPDOWN_PADDING;
        var availableSpaceAbove = referenceBoundingRect.top - DROPDOWN_PADDING;
        var shouldDropUp = dropdownHeight > availableSpaceBelow && availableSpaceAbove > availableSpaceBelow;
        var inputWidth = referenceBoundingRect.right - referenceBoundingRect.left;
        var widthDifference = dropdownNode.offsetWidth - inputWidth;
        var availableSpaceRight = window.innerWidth - referenceBoundingRect.right;
        var availableSpaceLeft = referenceBoundingRect.left;
        var shouldDropLeft = availableSpaceRight < widthDifference && availableSpaceLeft > widthDifference;
        dropdownCb.modifier('dropped-up', shouldDropUp);
        dropdownCb.modifier('dropped-left', shouldDropLeft);
        addClass(dropdownNode, dropdownCb.toString());
    }
}
function openDropdown(open, onOpen) {
    if (!open) {
        onOpen();
    }
}
function closeDropdown(open, onClose) {
    if (open) {
        onClose();
    }
}
function handleKeydown(e, open, onClose) {
    if (e.keyCode === KeyCode.escape) {
        e.currentTarget.querySelector('.awsui-input-dropdown__input input').focus();
        closeDropdown(open, onClose);
    }
}
function handleInputKeydown(e, focusContent, open, onOpen) {
    if (e.keyCode === KeyCode.down) {
        openDropdown(open, onOpen);
        focusContent();
    }
}
export default (function (_a) {
    var input = _a.input, content = _a.content, isOpen = _a.isOpen, onOpen = _a.onOpen, onClose = _a.onClose, focusContent = _a.focusContent;
    var dropdownCb = new BemClassBuilder({ __componentName: 'awsui-input-dropdown' }, 'dropdown');
    dropdownCb.modifier('open', isOpen);
    var isBlurPrevented = false;
    var preventBlur = function () { return (isBlurPrevented = true); };
    var handleBlur = function (e) {
        if (isBlurPrevented) {
            isBlurPrevented = false;
            // We need to wrap this .focus() call with setTimeout because Firefox has problem
            // with calling .focus() directly from a blur/focusout handler.
            // See https://bugzilla.mozilla.org/show_bug.cgi?id=53579 for more details.
            setTimeout(function () {
                // steal back focus to the blurred input
                e.target.focus();
            });
            return;
        }
        // ignore blur if we're focussing something else in the dropdown
        if (e.relatedTarget && e.currentTarget.parentElement.contains(e.relatedTarget)) {
            return;
        }
        closeDropdown(isOpen, onClose);
    };
    return (AwsUi.__createElement("div", { className: new BemClassBuilder({ __componentName: 'awsui-input-dropdown' }, 'container').toString(), onkeydown: function (e) { return handleKeydown(e, isOpen, onClose); } },
        AwsUi.__createElement("div", { className: new BemClassBuilder({ __componentName: 'awsui-input-dropdown' }, 'input').toString(), onclick: function () { return openDropdown(isOpen, onOpen); }, onfocusin: function () { return openDropdown(isOpen, onOpen); }, onfocusout: function (e) { return handleBlur(e); }, onkeydown: function (e) { return handleInputKeydown(e, focusContent, isOpen, onOpen); } }, input),
        AwsUi.__createElement("div", { className: dropdownCb.toString(), lifecycleKey: "awsui-input-dropdown", onmousedown: function () { return preventBlur(); }, componentDidMount: function (element) { return open && fitDropdown(element); }, componentDidUpdate: function (element) { return open && fitDropdown(element); } }, isOpen && content)));
});
//# sourceMappingURL=dropdown.js.map